/**
 * Phase 24.4b Step 6 — composes DayHeader + 4 MealCards into a single
 * day column / accordion section.
 */
import type { DayTotals } from "@/api/meal_plan";
import { DayHeader } from "./DayHeader";
import { MealCard } from "./MealCard";

interface Props {
  day: DayTotals;
  expanded: boolean;
  onToggle?: () => void;
  onMealClick: (itemId: number, recipeId: number) => void;
}

const MEAL_TYPE_ORDER: Record<string, number> = {
  breakfast: 0,
  pre_workout: 1,
  lunch: 2,
  post_workout: 3,
  snack: 4,
  dinner: 5,
};

export function DayColumn({ day, expanded, onToggle, onMealClick }: Props) {
  const sortedItems = [...day.items].sort(
    (a, b) =>
      (MEAL_TYPE_ORDER[a.meal_type] ?? 99) -
      (MEAL_TYPE_ORDER[b.meal_type] ?? 99),
  );

  return (
    <div
      className="space-y-2"
      data-testid="day-column"
      data-day-column-date={day.date}
    >
      <DayHeader day={day} expanded={expanded} onToggle={onToggle} />
      {expanded ? (
        <div className="space-y-2">
          {sortedItems.map((item) => (
            <MealCard
              key={item.id}
              item={item}
              onClick={() => onMealClick(item.id, item.recipe.id)}
            />
          ))}
        </div>
      ) : null}
    </div>
  );
}
